import { useMemo } from "react";
import useFetchGraphData from "../useFetchGraphData";
import { parseLocalDate } from "../../utils";

export default function useInflowSeries({
  parameterGroup = [],
  startDate,
  endDate,
  locationIds,
}) {
  const {
    data,
    isFetching: isLoading,
    isError,
  } = useFetchGraphData(
    {
      parameterGroup: parameterGroup.join(","),
      start_date: startDate,
      end_date: endDate,
      locationIds: locationIds.join(","),
    },
    "results-simple/ccr-inflow"
  );

  const { series, unit, parameter } = useMemo(() => {
    if (!data?.length) return { series: [], unit: "", parameter: "" };

    const grouped = {};

    data.forEach((d) => {
      const key = `${d.location_name}::${d.parameter}`;
      if (!grouped[key]) grouped[key] = [];

      grouped[key].push({
        x: parseLocalDate(d.rdate),
        y: d.rvalue_converted,
        parameter: d.parameter,
        location_name: d.location_name,
        unit: d.unit_name,
        date: d.rdate,
      });
    });

    const series = Object.entries(grouped).map(([key, points], i) => {
      const [location, param] = key.split("::");
      return {
        label: `${location}, ${param}`,
        data: points,
        location,
        parameter: param,
        unit: points[0].unit,
        colorIndex: i,
      };
    });

    return {
      series,
      unit: data[0].unit_name,
      parameter: data[0].parameter,
    };
  }, [data]);

  return { series, unit, parameter, isLoading, isError };
}
